export default "__VITE_ASSET__Djh1qB2$__"